// extracted by extract-css-chunks-webpack-plugin
module.exports = {"input":"_9f1d0oJg56fE","inputWithMessage":"_5aWfYL6cBh26","button":"gWVJ6moqKO9h"};